import React,{Component} from 'react';

class NumberDisplay extends Component {
    formatNumberWithCommas(amountString) {
        if (typeof amountString !== 'string') {
          return 'Invalid Input'; // Handle non-string input
        }
    
        // Attempt to convert the string to a number
        const number = parseFloat(amountString.replace(/,/g, '')); //remove commas then convert.
    
        if (isNaN(number)) {
          return 'Invalid Number'; // Handle cases where the string is not a valid number
        }
    
        return number.toLocaleString();
      }

  render() {
    const formattedValue = this.formatNumberWithCommas(this.props.value);
    return <span>{formattedValue}</span>;
  }
}

export default NumberDisplay